const SvgWarningTriangle = () => (
	<svg width="1em" height="1em" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M11.23 1.198c.759-1.385 2.748-1.385 3.507 0l10.057 18.34c.731 1.333-.233 2.962-1.753 2.962H2.926c-1.52 0-2.484-1.629-1.754-2.962L11.23 1.198Z"
			fill="#100D3D"
		/>
		<path
			d="M14.08 15.62c.224-1.231.384-3.375.384-5.503V7.429H12.16v2.688c0 2.08.144 4.224.352 5.504h1.568Zm-.768 3.713c.688 0 1.28-.576 1.28-1.264 0-.704-.592-1.28-1.28-1.28-.72 0-1.312.576-1.312 1.28 0 .688.592 1.264 1.312 1.264Z"
			fill="#F6F6F6"
		/>
	</svg>
)

export default SvgWarningTriangle
